import colors from "../../../styles/colors/colors";

export const ReviewDetailsFeildsGrid = () => ({
  padding: "1.5rem 0rem 0.8rem 0rem",
});

export const ReviewDetailsOutterGrid = () => ({
  backgroundColor: colors.backgroundColor[2],
});

export const ReviewDetailsLeftColumnGrid = () => ({
  borderRight: `1px solid ${colors.borders[1]}`,
  marginBottom: "0.6rem",
});

export const ReviewDetailsGridHeading = () => ({
  display: "flex",
  alignItems: "center",
});
export const ReviewDetailsRowGrid = () => ({
  borderBottom: `1px dashed ${colors.borders[1]}`,
  margin: "0.5rem 1.5rem",
  paddingBottom: "1rem",
});

export const ReviewDetailsRightColumnGrid = () => ({
  paddingLeft: "2rem",
});

export const ReviewDetailEmergencyContactTable = () => ({
  "& .MuiTableCell-root": {
    border: 0,
    padding: "0.5rem 0 0.5rem 0rem",
  },
});

export const TableHeadStyle = () => ({
  backgroundColor: "none",
  marginBottom: "0.2rem",
  "& .MuiTableCell-root": {
    padding: "1.5rem 0.3rem 0rem 0rem",
    borderBottom: "none",
  },
  "& th:first-of-type": {
    borderBottom: "none",
  },
  "& th:last-of-type": {
    borderBottom: "none",
  },
});

export const ReviewDetailsEMCtable = () => ({
  padding: "0 0.5rem 0 0 ",
});

export const ReviewDetailsFields = () => ({
  display: "flex",
  wordBreak: "break-word",
});

export const ReviewDetailsLastRowGrid = () => ({
  margin: "0.5rem 1.5rem",
});

export const DocumentsListGrid = () => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flexWrap: "wrap",
});

export const ReviewCertifyFields = () => ({
  paddingTop: "0.8rem",
  display: "flex",
});

export const DateControl = () => ({
  margin: "0.7rem 0.4rem 0.7rem 0rem",
  width: "20rem",
});

export const SelectControl = () => ({
  margin: "0.7rem",
  width: "20rem",
  paddingLeft: "1rem",
});

export const ReviewDocumentTypeIcon = () => ({
  color: colors.fonts[18],
  padding: "0.25rem 0.5rem 0 0rem",
});

export const DocDividerStyle = () => ({
  height: "1.7rem",
  border: `1px solid ${colors.borders[2]}`,
  margin: "0 0.5rem",
});

export const DocumentAlignment = () => ({
  display: "flex",
  paddingBottom: "1rem",
  alignItems: "center",
});

export const DividerMargin = () => ({
  margin: "0rem 0.5rem 0rem -0.5rem",
});
